import { useField } from 'formik';
import React from 'react';

import { HiddenInput, Label } from './styles';

export type PropTypes = React.InputHTMLAttributes<HTMLInputElement> &
  Pick<React.ButtonHTMLAttributes<HTMLButtonElement>, 'onClick'>;

const CardRadioButton = ({ children, name, value, ...props }: PropTypes): JSX.Element => {
  const [field, , { setValue }] = useField({ name, ...props });

  const checked = value === field.value;

  return (
    <button
      type="button"
      data-testid={`card-radio-button-${value}`}
      onClick={(event): void => {
        props.onClick?.(event);
        if (checked) setValue(undefined);
      }}
    >
      <HiddenInput
        {...field}
        id={`radio-button-${name}-${value}`}
        type="radio"
        name={name}
        value={value}
        checked={checked}
        onChange={(event): void => {
          event.persist();
          props.onChange?.(event);
          setValue(value);
        }}
      />
      <Label checked={checked} htmlFor={`radio-button-${name}-${value}`}>
        {children}
      </Label>
    </button>
  );
};

export default CardRadioButton;
